





























import Vue from 'vue'
import { TelenorForYouElInterface } from '@/config/interfaces'

// Not in use since RBR, but in case we need it...
export default Vue.extend({
  name: 'TelenorForYouEl',

  props: {
    templateItemData: {
      type: Object as () => TelenorForYouElInterface,
      required: true
    }
  }
})
